import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            四大核心优势，打造极致漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 md:p-7 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}